// extracted by mini-css-extract-plugin
export default {"legend":"style_legend__4H6Sn","closed":"style_closed__IC7O6","container":"style_container__x2acj","bottomCheckbox":"style_bottomCheckbox__fNPQA","close":"style_close__4J2nZ"};